var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    [
      _c("label", { attrs: { for: "date_name" } }, [
        _vm._v(_vm._s(_vm._f("capitalize")(_vm.content.key)))
      ]),
      _vm._v(" "),
      _vm.content.required
        ? _c("sup", { staticClass: "text-danger required-css" }, [
            _c("i", { staticClass: "fa fa-asterisk" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.content.current_value
        ? _c("span", [
            _vm.content.date_format
              ? _c("span", [
                  _c("i", [_vm._v("(" + _vm._s(_vm.content.date_format) + ")")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.content.edited
              ? _c(
                  "span",
                  {
                    staticClass: "badge",
                    style: { color: "#FFFFFF", backgroundColor: "#170c9e" },
                    attrs: { title: _vm.$t("FORMS.CON_SCORE") }
                  },
                  [_vm._v("100")]
                )
              : _c(
                  "span",
                  {
                    staticClass: "badge",
                    style: { backgroundColor: _vm.content.color_code },
                    attrs: { title: _vm.$t("FORMS.CON_SCORE") }
                  },
                  [_vm._v(_vm._s(Math.round(_vm.content.confidence * 100)))]
                )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.content.edited
        ? _c("span", { staticClass: "badge badge-edited" }, [
            _c("i", {
              staticClass: "fa fa-check",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" Edited")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.content.is_auto_correct && _vm.autoCorrectFlag
        ? _c("span", { staticClass: "badge badge-auto-corrected" }, [
            _c("i", {
              staticClass: "fa fa-check",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" Auto-Corrected")
          ])
        : _vm.content.auto_correct_enable && _vm.autoCorrectFlag
          ? _c("span", { staticClass: "badge badge-auto_correct_enable" }, [
              _c("i", {
                staticClass: "fa fa-check",
                attrs: { "aria-hidden": "true" }
              }),
              _vm._v(" Auto-Correct-Enable")
            ])
          : _vm._e(),
      _vm._v(" "),
      _c("date-picker", {
        attrs: {
          id: "date_name",
          "value-type": "format",
          lang: "en",
          format: "MM-DD-YYYY",
          "append-to-body": "",
          clearable: false,
          width: "100%"
        },
        on: { input: _vm.handleDateInput },
        model: {
          value: _vm.date,
          callback: function($$v) {
            _vm.date = $$v
          },
          expression: "date"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ddbc0728", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddbc0728","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/process/dateField.vue
// module id = 1162
// module chunks = 2